
// lesson data 

export const data =
{
        "classTitle": "KS3",
        "studentClass": "623039992c9f8e0be9decae1",
        "subjectName": "Biology",
        "topicQuiz": [
        "Test Quiz Third"
        ],
        "isActive": true,
        "isDeleted": false,
        "_id": "623c715ae8e3cf3b03364b56",
        "topicTitle": "cell",
        "topicText": [
            "<p class=\"title-content\"><span style=\"background-color:#e74c3c\">A cell is&nbsp;</span><strong><span style=\"background-color:#e74c3c\">a mass of cytoplasm that is bound externally by a cell membrane</span></strong><span style=\"background-color:#e74c3c\">. Usually microscopic in</span><span style=\"color:#2ecc71\"><span style=\"background-color:#e74c3c\"> size,</span></span><span style=\"background-color:#e74c3c\"> cells are the smallest structural units of living matter and compose all living things. Most cells have one or more nuclei and other organelles that carry out a variety of tasks.</span></p>\n<p class=\"title-content\"><img alt=\"Parts of the cell Images, Stock Photos &amp; Vectors | Shutterstock\" src=\"https://image.shutterstock.com/image-vector/animal-cell-labeled-anatomical-structure-260nw-1992808598.jpg\" /></p>\n<p class=\"title-content\"><strong><span style=\"background-color:#2ecc71\">cell</span></strong><span style=\"background-color:#2ecc71\">, In biology, the basic unit of which all living things are composed; the smallest structural unit of living matter that is able to function independently. A single cell can be a complete organism in itself, as in&nbsp;</span><a href=\"https://www.britannica.com/summary/bacteria\"><span style=\"background-color:#2ecc71\">bacteria</span></a><span style=\"background-color:#2ecc71\">&nbsp;and&nbsp;</span><a href=\"https://www.britannica.com/summary/protozoan\"><span style=\"background-color:#2ecc71\">protozoans</span></a><span style=\"background-color:#2ecc71\">. Groups of specialized cells are organized into tissues and organs in multicellular organisms such as higher plants and animals. There are two distinct types of cells: prokaryotic cells and eukaryotic cells. Though the structures of prokaryotic and eukaryotic cells differ (</span><em><span style=\"background-color:#2ecc71\">see</span></em><span style=\"background-color:#2ecc71\">&nbsp;prokaryote, eukaryote), their molecular compositions and activities are very similar. The chief molecules in cells are&nbsp;</span><a href=\"https://www.britannica.com/summary/nucleic-acid\"><span style=\"background-color:#2ecc71\">nucleic acids</span></a><span style=\"background-color:#2ecc71\">,&nbsp;</span><a href=\"https://www.britannica.com/summary/protein\"><span style=\"background-color:#2ecc71\">proteins</span></a><span style=\"background-color:#2ecc71\">, and polysaccharides. A cell is bounded by a membrane that enables it to exchange certain materials with its surroundings. In plant cells, a rigid cell wall encloses this membrane.</span></p>\n\n<p class=\"title-content\">&nbsp;</p>\n\n<p class=\"title-content\"><a href=\"https://cdn.britannica.com/34/72134-004-16996CD2/Cytoplasm-cell-structures-organelles-Ribosomes-sites-protein.jpg\"><img alt=\"animal cell\" src=\"https://cdn.britannica.com/34/72134-004-16996CD2/Cytoplasm-cell-structures-organelles-Ribosomes-sites-protein.jpg?w=740&amp;h=416&amp;c=crop\" /></a></p>\n\n<p class=\"title-content\"><a href=\"https://cdn.britannica.com/34/72134-004-16996CD2/Cytoplasm-cell-structures-organelles-Ribosomes-sites-protein.jpg\">animal cell</a></p>\n\n<p class=\"title-content\"><span style=\"color:#e67e22\">Principal structures of an animal cellCytoplasm surrounds the cell&#39;s specialized structures, or organelles. Ribosomes, the sites of protein synthesis, are found free in the cytoplasm or attached to the endoplasmic reticulum, through which materials are transported throughout the cell. Energy needed by the cell is released by the mitochondria. The Golgi complex, stacks of flattened sacs, processes and packages materials to be released from the cell in secretory vesicles. Digestive enzymes are contained in lysosomes. Peroxisomes contain enzymes that detoxify dangerous substances. The centrosome contains the centrioles, which play a role in cell division. The microvilli are fingerlike extensions found on certain cells. Cilia, hairlike structures that extend from the surface of many cells, can create movement of surrounding fluid. The nuclear envelope, a double membrane surrounding the nucleus, contains pores that control the movement of substances into and out of the nucleoplasm. Chromatin, a combination of DNA and proteins that coil into chromosomes, makes up much of the nucleoplasm. The dense nucleolus is the site of ribosome production.</span></p>\n\n",
            "<p class=\"title-content\">The&nbsp;<strong>cell</strong>&nbsp;(from the&nbsp;<a href=\"https://en.wikipedia.org/wiki/Latin\" title=\"Latin\">Latin</a>&nbsp;word &#39;cellula&#39; meaning &quot;small room&quot;<sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-npr12-1\">[1]</a></sup>) is the basic structural and functional unit of&nbsp;<a href=\"https://en.wikipedia.org/wiki/Life_form\" title=\"Life form\">life forms</a>. Every cell consists of a&nbsp;<a href=\"https://en.wikipedia.org/wiki/Cytoplasm\" title=\"Cytoplasm\">cytoplasm</a>&nbsp;enclosed within a&nbsp;<a href=\"https://en.wikipedia.org/wiki/Cell_membrane\" title=\"Cell membrane\">membrane</a>, which contains many&nbsp;<a href=\"https://en.wikipedia.org/wiki/Biomolecule\" title=\"Biomolecule\">biomolecules</a>&nbsp;such as&nbsp;<a href=\"https://en.wikipedia.org/wiki/Protein\" title=\"Protein\">proteins</a>&nbsp;and&nbsp;<a href=\"https://en.wikipedia.org/wiki/Nucleic_acid\" title=\"Nucleic acid\">nucleic acids</a>.<sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-Alberts20022-2\">[2]</a></sup></p>\n\n<p class=\"title-content\">Cells can acquire specified function and carry out various tasks within the cell such as replication, DNA repair, protein synthesis, and motility. Cells are capable of specialization and mobility within the cell. Most cells are measured in micrometers due to their small size.</p>\n\n<p class=\"title-content\">Most plant and animal cells are only visible under a&nbsp;<a href=\"https://en.wikipedia.org/wiki/Light_microscope\" title=\"Light microscope\">light microscope</a>, with dimensions between 1 and 100&nbsp;<a href=\"https://en.wikipedia.org/wiki/Micrometre\" title=\"Micrometre\">micrometres</a>.<sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-3\">[3]</a></sup>&nbsp;<a href=\"https://en.wikipedia.org/wiki/Electron_microscopy\" title=\"Electron microscopy\">Electron microscopy</a>&nbsp;gives a much higher resolution showing greatly detailed cell structure. Organisms can be classified as&nbsp;<a href=\"https://en.wikipedia.org/wiki/Unicellular\" title=\"Unicellular\">unicellular</a>&nbsp;(consisting of a single cell such as&nbsp;<a href=\"https://en.wikipedia.org/wiki/Bacteria\" title=\"Bacteria\">bacteria</a>) or&nbsp;<a href=\"https://en.wikipedia.org/wiki/Multicellular\" title=\"Multicellular\">multicellular</a>&nbsp;(including plants and animals).<sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-NCBI2-4\">[4]</a></sup>&nbsp;Most&nbsp;<a href=\"https://en.wikipedia.org/wiki/Unicellular_organism\" title=\"Unicellular organism\">unicellular organisms</a>&nbsp;are classed as&nbsp;<a href=\"https://en.wikipedia.org/wiki/Microorganism\" title=\"Microorganism\">microorganisms</a>. The number of cells in plants and animals varies from species to species; it has been approximated that the human body contains an estimated 37 trillion (3.72&times;10<sup>13</sup>) cells<sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-5\">[5]</a></sup>. The brain accounts for around 80 billion of these cells.<sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-JCN2-6\">[6]</a></sup></p>\n\n<p class=\"title-content\">The study of cells and how they work has led to many other studies in the field. Including but not limited to; the discovery of DNA, cancer study development, as well as aging and development.</p>\n\n<p class=\"title-content\">Cells emerged on Earth about 4 billion years ago.&nbsp;<a href=\"https://en.wikipedia.org/wiki/Cell_biology\" title=\"Cell biology\">Cell biology</a>&nbsp;is the study of cells, which were discovered by&nbsp;<a href=\"https://en.wikipedia.org/wiki/Robert_Hooke\" title=\"Robert Hooke\">Robert Hooke</a>&nbsp;in 1665, who named them for their resemblance to&nbsp;<a href=\"https://en.wikipedia.org/wiki/Monastic_cell\" title=\"Monastic cell\">cells</a>&nbsp;inhabited by&nbsp;<a href=\"https://en.wikipedia.org/wiki/Christian_monasticism\" title=\"Christian monasticism\">Christian monks</a>&nbsp;in a monastery.<sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-Karp20092-7\">[7]</a></sup><sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-8\">[8]</a></sup>&nbsp;<a href=\"https://en.wikipedia.org/wiki/Cell_theory\" title=\"Cell theory\">Cell theory</a>, first developed in 1839 by&nbsp;<a href=\"https://en.wikipedia.org/wiki/Matthias_Jakob_Schleiden\" title=\"Matthias Jakob Schleiden\">Matthias Jakob Schleiden</a>&nbsp;and&nbsp;<a href=\"https://en.wikipedia.org/wiki/Theodor_Schwann\" title=\"Theodor Schwann\">Theodor Schwann</a>, states that all organisms are composed of one or more cells, that cells are the fundamental unit of structure and function in all living organisms, and that all cells come from pre-existing cells.<sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-9\">[9]</a></sup>&nbsp;Cells emerged on Earth about 4 billion years ago.<sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-Origin12-10\">[10]</a></sup><sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-Origin22-11\">[11]</a></sup><sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-RavenJohnson20022-12\">[12]</a></sup><sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-13\">[13]</a></sup></p>\n",
            "<p class=\"title-content\">Prokaryotic cells</p>\n\n<p class=\"title-content\">Main article:&nbsp;<a href=\"https://en.wikipedia.org/wiki/Prokaryote\" title=\"Prokaryote\">Prokaryote</a></p>\n\n<p class=\"title-content\"><a href=\"https://en.wikipedia.org/wiki/File:Prokaryote_cell.svg\"><img alt=\"\" src=\"https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Prokaryote_cell.svg/280px-Prokaryote_cell.svg.png\" style=\"height:314px; width:280px\" /></a></p>\n\n<p class=\"title-content\">Structure of a typical&nbsp;<a href=\"https://en.wikipedia.org/wiki/Prokaryotic\" title=\"Prokaryotic\">prokaryotic</a>&nbsp;cell</p>\n\n<p class=\"title-content\"><a href=\"https://en.wikipedia.org/wiki/Prokaryote\" title=\"Prokaryote\">Prokaryotes</a>&nbsp;include&nbsp;<a href=\"https://en.wikipedia.org/wiki/Bacteria\" title=\"Bacteria\">bacteria</a>&nbsp;and&nbsp;<a href=\"https://en.wikipedia.org/wiki/Archaea\" title=\"Archaea\">archaea</a>, two of the&nbsp;<a href=\"https://en.wikipedia.org/wiki/Three_domain_system\" title=\"Three domain system\">three</a>&nbsp;<a href=\"https://en.wikipedia.org/wiki/Domain_(biology)\" title=\"Domain (biology)\">domains of life</a>. Prokaryotic cells were the first form of&nbsp;<a href=\"https://en.wikipedia.org/wiki/Life\" title=\"Life\">life</a>&nbsp;on Earth, characterized by having vital&nbsp;<a href=\"https://en.wikipedia.org/wiki/Biological_process\" title=\"Biological process\">biological processes</a>&nbsp;including&nbsp;<a href=\"https://en.wikipedia.org/wiki/Cell_signaling\" title=\"Cell signaling\">cell signaling</a>. They are simpler and smaller than eukaryotic cells, and lack a&nbsp;<a href=\"https://en.wikipedia.org/wiki/Cell_nucleus\" title=\"Cell nucleus\">nucleus</a>, and other membrane-bound&nbsp;<a href=\"https://en.wikipedia.org/wiki/Organelle\" title=\"Organelle\">organelles</a>. The&nbsp;<a href=\"https://en.wikipedia.org/wiki/DNA\" title=\"DNA\">DNA</a>&nbsp;of a prokaryotic cell consists of a single&nbsp;<a href=\"https://en.wikipedia.org/wiki/Circular_prokaryote_chromosome\" title=\"Circular prokaryote chromosome\">circular chromosome</a>&nbsp;that is in direct contact with the&nbsp;<a href=\"https://en.wikipedia.org/wiki/Cytoplasm\" title=\"Cytoplasm\">cytoplasm</a>. The nuclear region in the cytoplasm is called the&nbsp;<a href=\"https://en.wikipedia.org/wiki/Nucleoid\" title=\"Nucleoid\">nucleoid</a>. Most prokaryotes are the smallest of all organisms ranging from 0.5 to 2.0&nbsp;&mu;m in diameter.<sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-15\">[15]</a></sup></p>\n\n<p class=\"title-content\">&nbsp;</p>\n",
            "<p class=\"title-content\"><a href=\"https://en.wikipedia.org/wiki/File:Plant_cell_structure-en.svg\"><img alt=\"\" src=\"https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/Plant_cell_structure-en.svg/280px-Plant_cell_structure-en.svg.png\" style=\"height:205px; width:280px\" /></a></p>\n",
            "<p class=\"title-content\">Cell membrane</p>\n\n<p class=\"title-content\">Main article:&nbsp;<a href=\"https://en.wikipedia.org/wiki/Cell_membrane\" title=\"Cell membrane\">Cell membrane</a></p>\n\n<p class=\"title-content\"><a href=\"https://en.wikipedia.org/wiki/File:Cell_membrane_detailed_diagram_en.svg\"><img alt=\"\" src=\"https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Cell_membrane_detailed_diagram_en.svg/300px-Cell_membrane_detailed_diagram_en.svg.png\" style=\"height:123px; width:300px\" /></a></p>\n\n<p class=\"title-content\">Detailed diagram of lipid bilayer of cell membrane</p>\n\n<p class=\"title-content\">The&nbsp;<a href=\"https://en.wikipedia.org/wiki/Cell_membrane\" title=\"Cell membrane\">cell membrane</a>, or plasma membrane, is a selectively permeable<sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-24\">[24]</a></sup>&nbsp;<a href=\"https://en.wikipedia.org/wiki/Biological_membrane\" title=\"Biological membrane\">biological membrane</a>&nbsp;that surrounds the cytoplasm of a cell. In animals, the plasma membrane is the outer boundary of the cell, while in plants and prokaryotes it is usually covered by a&nbsp;<a href=\"https://en.wikipedia.org/wiki/Cell_wall\" title=\"Cell wall\">cell wall</a>. This membrane serves to separate and protect a cell from its surrounding environment and is made mostly from a&nbsp;<a href=\"https://en.wikipedia.org/wiki/Lipid_bilayer\" title=\"Lipid bilayer\">double layer of phospholipids</a>, which are&nbsp;<a href=\"https://en.wikipedia.org/wiki/Amphiphilic\" title=\"Amphiphilic\">amphiphilic</a>&nbsp;(partly&nbsp;<a href=\"https://en.wikipedia.org/wiki/Hydrophobic\" title=\"Hydrophobic\">hydrophobic</a>&nbsp;and partly&nbsp;<a href=\"https://en.wikipedia.org/wiki/Hydrophilic\" title=\"Hydrophilic\">hydrophilic</a>). Hence, the layer is called a&nbsp;<a href=\"https://en.wikipedia.org/wiki/Phospholipid_bilayer\" title=\"Phospholipid bilayer\">phospholipid bilayer</a>, or sometimes a fluid mosaic membrane. Embedded within this membrane is a macromolecular structure called the&nbsp;<a href=\"https://en.wikipedia.org/wiki/Porosome\" title=\"Porosome\">porosome</a>&nbsp;the universal secretory portal in cells and a variety of&nbsp;<a href=\"https://en.wikipedia.org/wiki/Protein\" title=\"Protein\">protein</a>&nbsp;molecules that act as channels and pumps that move different molecules into and out of the cell.<sup><a href=\"https://en.wikipedia.org/wiki/Cell_(biology)#cite_note-NCBI-16\">[16]</a></sup>&nbsp;The membrane is semi-permeable, and selectively permeable, in that it can either let a substance (<a href=\"https://en.wikipedia.org/wiki/Molecule\" title=\"Molecule\">molecule</a>&nbsp;or&nbsp;<a href=\"https://en.wikipedia.org/wiki/Ion\" title=\"Ion\">ion</a>) pass through freely, pass through to a limited extent or not pass through at all. Cell surface membranes also contain&nbsp;<a href=\"https://en.wikipedia.org/wiki/Receptor_(biochemistry)#Transmembrane_receptors\" title=\"Receptor (biochemistry)\">receptor</a>&nbsp;proteins that allow cells to detect external signaling molecules such as&nbsp;<a href=\"https://en.wikipedia.org/wiki/Hormone\" title=\"Hormone\">hormones</a>.</p>\n",
            "<p class=\"title-content\">enetic material</p>\n\n<p class=\"title-content\">Main articles:&nbsp;<a href=\"https://en.wikipedia.org/wiki/DNA\" title=\"DNA\">DNA</a>&nbsp;and&nbsp;<a href=\"https://en.wikipedia.org/wiki/RNA\" title=\"RNA\">RNA</a></p>\n\n<p class=\"title-content\"><a href=\"https://en.wikipedia.org/wiki/File:DNA_orbit_animated.gif\"><img alt=\"\" src=\"https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/DNA_orbit_animated.gif/220px-DNA_orbit_animated.gif\" style=\"height:362px; width:220px\" /></a></p>\n"
        ],
        "topicOrderIndex": 1,
        "created": "2022-03-24T13:25:46.959Z",
        "updated": "2022-03-24T13:25:46.959Z",
        "topicTitleIndexs": [
            "Epithelial Cells. These cells are tightly attached to one another. ...",
            "Nerve Cells. These cells are specialized for communication. ...",
            "Muscle Cells. These cells are specialized for contraction. ...",
            " Connective Tissue Cells",
            " There are about 200 different types of cells in the body.",
            "Characteristics of Cells"
        ],
        "easyPercentage": "40",
        "mediumPercentage": "40",
        "hardPercentage": "20",
        "numberPracticeQuestions": "11",
        "numberHomeworkQuestions": "25",
        "time": "01:00:13"
    }


    //homework data 

    
export const homeWorkData =
    {
        "parsentage": "0",
        "totalMarks": 34,
        "getMarks": 0,
        "workFlowStatus": "Runing",
        "attemptData": [],
        "questions": [
            {
                "_id": "627bbdefbe9ecf108fe1a701",
                "hardtype": "easy",
                "tags": [
                    "test"
                ],
                "placeHolders": [],
                "answerOptions": [
                    "a"
                ],
                "optionvalues": [],
                "xvalues": [],
                "yvalues": [],
                "isActive": true,
                "isDeleted": false,
                "questionTitle": "<p>What magnification was the student using</p>\n",
                "subjectId": "62303c512c9f8e0be9decb06",
                "questionType": "descriptive",
                "subjectTitle": "Biology",
                "explaination": "What magnification was the student using",
                "rightAnawer": "[object Object]",
                "classId": "623039992c9f8e0be9decae1",
                "classTitle": "KS3",
                "chapterId": "623053322c9f8e0be9decc6a",
                "chapterTitle": "The FundaMental Unit Of Life 2",
                "questionMarks": "2",
                "topicId": "623c715ae8e3cf3b03364b56",
                "topicTitle": "cell",
                "created": "2022-05-11T13:45:19.480Z",
                "updated": "2022-05-11T13:45:19.480Z",
                "__v": 0
            },
            {
                "_id": "6287633d36dd500d0117e245",
                "hardtype": "easy",
                "tags": [
                    "demo"
                ],
                "placeHolders": [
                    "manish",
                    "jaipur"
                ],
                "answerOptions": [],
                "optionvalues": [],
                "xvalues": [],
                "yvalues": [],
                "isActive": true,
                "isDeleted": false,
                "questionTitle": "my name is _____ , and i from _____",
                "subjectId": "62303c512c9f8e0be9decb06",
                "questionType": "fill",
                "subjectTitle": "Biology",
                "explaination": "Fill Type questions ",
                "rightAnawer": "my name is manish , and i from jaipur",
                "classId": "623039992c9f8e0be9decae1",
                "classTitle": "KS3",
                "chapterId": "623053322c9f8e0be9decc6a",
                "chapterTitle": "The FundaMental Unit Of Life 2",
                "questionMarks": "2",
                "topicId": "623c715ae8e3cf3b03364b56",
                "topicTitle": "cell",
                "created": "2022-05-20T09:45:33.417Z",
                "updated": "2022-05-20T09:45:33.417Z",
                "__v": 0
            },
            {
                "_id": "627bb1e0be9ecf108fe1a4c2",
                "hardtype": "easy",
                "tags": [
                    "test "
                ],
                "placeHolders": [],
                "answerOptions": [
                    "test",
                    "grass",
                    "tree"
                ],
                "optionvalues": [],
                "xvalues": [],
                "yvalues": [],
                "isActive": true,
                "isDeleted": false,
                "questionTitle": "<p>Which of the following is NOT true</p>\n",
                "subjectId": "62303c512c9f8e0be9decb06",
                "questionType": "optional",
                "subjectTitle": "Biology",
                "explaination": "option 3 is coreect",
                "rightAnawer": "2",
                "classId": "623039992c9f8e0be9decae1",
                "classTitle": "KS3",
                "chapterId": "623053322c9f8e0be9decc6a",
                "chapterTitle": "The FundaMental Unit Of Life 2",
                "questionMarks": "10",
                "topicId": "623c715ae8e3cf3b03364b56",
                "topicTitle": "cell",
                "created": "2022-05-11T12:53:52.816Z",
                "updated": "2022-05-11T12:53:52.816Z",
                "__v": 0
            },
            {
                "_id": "627bbc57be9ecf108fe1a6c7",
                "hardtype": "easy",
                "tags": [],
                "placeHolders": [],
                "answerOptions": [
                    "effect"
                ],
                "optionvalues": [],
                "xvalues": [],
                "yvalues": [],
                "isActive": true,
                "isDeleted": false,
                "questionTitle": "<p>Describe the effect of temperature on the rate of reaction of the</p>\n",
                "subjectId": "62303c512c9f8e0be9decb06",
                "questionType": "descriptive",
                "subjectTitle": "Biology",
                "explaination": "Describe the effect of temperature on the rate of reaction of the",
                "rightAnawer": "[object Object]",
                "classId": "623039992c9f8e0be9decae1",
                "classTitle": "KS3",
                "chapterId": "623053322c9f8e0be9decc6a",
                "chapterTitle": "The FundaMental Unit Of Life 2",
                "questionMarks": "2",
                "topicId": "623c715ae8e3cf3b03364b56",
                "topicTitle": "cell",
                "created": "2022-05-11T13:38:31.852Z",
                "updated": "2022-05-11T13:38:31.852Z",
                "__v": 0
            },
            {
                "_id": "62876ced36dd500d0117e455",
                "hardtype": "medium",
                "tags": [
                    "f"
                ],
                "placeHolders": [],
                "answerOptions": [
                    "e",
                    "f",
                    "g",
                    "h"
                ],
                "optionvalues": [],
                "xvalues": [],
                "yvalues": [],
                "isActive": true,
                "isDeleted": false,
                "questionTitle": "<p>f</p>\n",
                "subjectId": "62303c512c9f8e0be9decb06",
                "questionType": "optional",
                "subjectTitle": "Biology",
                "explaination": "f",
                "rightAnawer": "1",
                "classId": "623039992c9f8e0be9decae1",
                "classTitle": "KS3",
                "chapterId": "623053322c9f8e0be9decc6a",
                "chapterTitle": "The FundaMental Unit Of Life 2",
                "questionMarks": "5",
                "topicId": "623c715ae8e3cf3b03364b56",
                "topicTitle": "cell",
                "created": "2022-05-20T10:26:53.460Z",
                "updated": "2022-05-20T10:26:53.460Z",
                "__v": 0
            },
            {
                "_id": "627bb3cabe9ecf108fe1a4f1",
                "hardtype": "medium",
                "tags": [
                    "test"
                ],
                "placeHolders": [
                    "cell"
                ],
                "answerOptions": [],
                "optionvalues": [],
                "xvalues": [],
                "yvalues": [],
                "isActive": true,
                "isDeleted": false,
                "questionTitle": "protein Synthesis is _____",
                "subjectId": "62303c512c9f8e0be9decb06",
                "questionType": "fill",
                "subjectTitle": "Biology",
                "explaination": "Fill Type questions ",
                "rightAnawer": "protein Synthesis is cell",
                "classId": "623039992c9f8e0be9decae1",
                "classTitle": "KS3",
                "chapterId": "623053322c9f8e0be9decc6a",
                "chapterTitle": "The FundaMental Unit Of Life 2",
                "questionMarks": "5",
                "topicId": "623c715ae8e3cf3b03364b56",
                "topicTitle": "cell",
                "created": "2022-05-11T13:02:02.235Z",
                "updated": "2022-05-11T13:02:02.235Z",
                "__v": 0
            },
            {
                "_id": "6296fa0e419e6b2db5d9c916",
                "hardtype": "medium",
                "tags": [
                    "test"
                ],
                "placeHolders": [],
                "answerOptions": [
                    "test "
                ],
                "optionvalues": [],
                "xvalues": [],
                "yvalues": [],
                "isActive": true,
                "isDeleted": false,
                "questionTitle": "<p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>\n",
                "subjectId": "62303c512c9f8e0be9decb06",
                "questionType": "descriptive",
                "subjectTitle": "Biology",
                "explaination": "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.",
                "rightAnawer": "[object Object]",
                "classId": "623039992c9f8e0be9decae1",
                "classTitle": "KS3",
                "chapterId": "623053322c9f8e0be9decc6a",
                "chapterTitle": "The FundaMental Unit Of Life 2",
                "questionMarks": "3",
                "topicId": "623c715ae8e3cf3b03364b56",
                "topicTitle": "cell",
                "created": "2022-06-01T05:33:02.139Z",
                "updated": "2022-06-01T05:33:02.139Z",
                "__v": 0
            },
            {
                "_id": "6287617936dd500d0117e201",
                "hardtype": "medium",
                "tags": [],
                "placeHolders": [],
                "answerOptions": [
                    "3"
                ],
                "optionvalues": [],
                "xvalues": [],
                "yvalues": [],
                "isActive": true,
                "isDeleted": false,
                "questionTitle": "<p>if 4*x = 12<br />\nwhat is value of x&nbsp;</p>\n",
                "subjectId": "62303c512c9f8e0be9decb06",
                "questionType": "descriptive",
                "subjectTitle": "Biology",
                "explaination": "x value 3",
                "rightAnawer": "[object Object]",
                "classId": "623039992c9f8e0be9decae1",
                "classTitle": "KS3",
                "chapterId": "623053322c9f8e0be9decc6a",
                "chapterTitle": "The FundaMental Unit Of Life 2",
                "questionMarks": "5",
                "topicId": "623c715ae8e3cf3b03364b56",
                "topicTitle": "cell",
                "created": "2022-05-20T09:38:01.123Z",
                "updated": "2022-05-20T09:38:01.124Z",
                "__v": 0
            }
        ],
        "type": "practice",
        "isActive": true,
        "isDeleted": false,
        "_id": "62c2be97348ce047fd8010da",
        "userId": "6261373bb2dbe46deb6d19b0",
        "completed": "start",
        "topicId": "623c715ae8e3cf3b03364b56",
        "topicTitle": "cell",
        "time": "01:00:13",
        "chapterId": "623053322c9f8e0be9decc6a",
        "subjectId": "62303c512c9f8e0be9decb06",
        "classId": "623039992c9f8e0be9decae1",
        "created": "2022-07-04T10:19:03.705Z",
        "updated": "2022-07-04T10:19:03.705Z"
    }



// practice question data


export  const practiceQuestionData = {
    "parsentage": "0",
    "totalMarks": 57,
    "getMarks": 0,
    "workFlowStatus": "Runing",
    "attemptData": [],
    "questions": [
        {
            "_id": "627bbc1bbe9ecf108fe1a6bb",
            "hardtype": "easy",
            "tags": [
                "test"
            ],
            "placeHolders": [],
            "answerOptions": [
                "Grass"
            ],
            "optionvalues": [],
            "xvalues": [],
            "yvalues": [],
            "isActive": true,
            "isDeleted": false,
            "questionTitle": "<p>Which of these describe the process of mitosis?</p>\n",
            "subjectId": "62303c512c9f8e0be9decb06",
            "questionType": "descriptive",
            "subjectTitle": "Biology",
            "explaination": "Which of these describe the process of mitosis?",
            "rightAnawer": "[object Object]",
            "classId": "623039992c9f8e0be9decae1",
            "classTitle": "KS3",
            "chapterId": "623053322c9f8e0be9decc6a",
            "chapterTitle": "The FundaMental Unit Of Life 2",
            "questionMarks": "4",
            "topicId": "623c715ae8e3cf3b03364b56",
            "topicTitle": "cell",
            "created": "2022-05-11T13:37:31.027Z",
            "updated": "2022-05-11T13:37:31.027Z",
            "__v": 0
        },
        {
            "_id": "627bbbcebe9ecf108fe1a6a3",
            "hardtype": "easy",
            "tags": [
                "test"
            ],
            "placeHolders": [],
            "answerOptions": [
                "test "
            ],
            "optionvalues": [],
            "xvalues": [],
            "yvalues": [],
            "isActive": true,
            "isDeleted": false,
            "questionTitle": "<p>What is the name given to the specifically shaped region of the enzyme where the reaction occurs?</p>\n",
            "subjectId": "62303c512c9f8e0be9decb06",
            "questionType": "descriptive",
            "subjectTitle": "Biology",
            "explaination": "What is the name given to the specifically shaped region of the enzyme where the reaction occurs?",
            "rightAnawer": "[object Object]",
            "classId": "623039992c9f8e0be9decae1",
            "classTitle": "KS3",
            "chapterId": "623053322c9f8e0be9decc6a",
            "chapterTitle": "The FundaMental Unit Of Life 2",
            "questionMarks": "2",
            "topicId": "623c715ae8e3cf3b03364b56",
            "topicTitle": "cell",
            "created": "2022-05-11T13:36:14.291Z",
            "updated": "2022-05-11T13:36:14.291Z",
            "__v": 0
        },
        {
            "_id": "62a870dcff8c562db80d8f71",
            "hardtype": "easy",
            "tags": [],
            "placeHolders": [],
            "answerOptions": [
                "Cells are arranged in proper and systematic order to form"
            ],
            "optionvalues": [],
            "xvalues": [],
            "yvalues": [],
            "isActive": true,
            "isDeleted": false,
            "questionTitle": "<p>why cell is called structuaral and functional unit of life?</p>\n",
            "subjectId": "62303c512c9f8e0be9decb06",
            "questionType": "descriptive",
            "subjectTitle": "Biology",
            "explaination": "Cells are arranged in proper and systematic order to form",
            "rightAnawer": "[object Object]",
            "classId": "623039992c9f8e0be9decae1",
            "classTitle": "KS3",
            "chapterId": "623053322c9f8e0be9decc6a",
            "chapterTitle": "The FundaMental Unit Of Life 2",
            "questionMarks": "5",
            "topicId": "623c715ae8e3cf3b03364b56",
            "topicTitle": "cell",
            "created": "2022-06-14T11:28:28.954Z",
            "updated": "2022-06-14T11:28:28.955Z",
            "__v": 0
        },
        {
            "_id": "627bbdefbe9ecf108fe1a701",
            "hardtype": "easy",
            "tags": [
                "test"
            ],
            "placeHolders": [],
            "answerOptions": [
                "a"
            ],
            "optionvalues": [],
            "xvalues": [],
            "yvalues": [],
            "isActive": true,
            "isDeleted": false,
            "questionTitle": "<p>What magnification was the student using</p>\n",
            "subjectId": "62303c512c9f8e0be9decb06",
            "questionType": "descriptive",
            "subjectTitle": "Biology",
            "explaination": "What magnification was the student using",
            "rightAnawer": "[object Object]",
            "classId": "623039992c9f8e0be9decae1",
            "classTitle": "KS3",
            "chapterId": "623053322c9f8e0be9decc6a",
            "chapterTitle": "The FundaMental Unit Of Life 2",
            "questionMarks": "2",
            "topicId": "623c715ae8e3cf3b03364b56",
            "topicTitle": "cell",
            "created": "2022-05-11T13:45:19.480Z",
            "updated": "2022-05-11T13:45:19.480Z",
            "__v": 0
        },
        {
            "_id": "627bbcb4be9ecf108fe1a6df",
            "hardtype": "easy",
            "tags": [
                "test"
            ],
            "placeHolders": [],
            "answerOptions": [
                "tissue 1"
            ],
            "optionvalues": [],
            "xvalues": [],
            "yvalues": [],
            "isActive": true,
            "isDeleted": false,
            "questionTitle": "<p>&nbsp;</p>\n\n<p>Name the type of cell in plants that can differentiate into different types of cell</p>\n",
            "subjectId": "62303c512c9f8e0be9decb06",
            "questionType": "descriptive",
            "subjectTitle": "Biology",
            "explaination": "Question\nName the type of cell in plants that can differentiate into different types of cell",
            "rightAnawer": "[object Object]",
            "classId": "623039992c9f8e0be9decae1",
            "classTitle": "KS3",
            "chapterId": "623053322c9f8e0be9decc6a",
            "chapterTitle": "The FundaMental Unit Of Life 2",
            "questionMarks": "2",
            "topicId": "623c715ae8e3cf3b03364b56",
            "topicTitle": "cell",
            "created": "2022-05-11T13:40:04.901Z",
            "updated": "2022-05-11T13:40:04.901Z",
            "__v": 0
        },
        {"_id":"62cd0f04a4379662c892fbbf","hardtype":"easy","tags":["skeleton"],"placeHolders":[],"answerOptions":[],"optionvalues":["eyes,lungs,foot"],"xvalues":["275,298,295"],"yvalues":["35,182,465"],"isActive":true,"isDeleted":false,"questionTitle":"Image Type Question","subjectId":"62303c512c9f8e0be9decb06","subjectTitle":"Biology","questionType":"image","explaination":"","rightAnawer":"","classId":"623039992c9f8e0be9decae1","classTitle":"KS3 / KS3 Crash Course","imagePath":"https://uat-lpi-tuition.projectstatus.in/images/1657605892872-mini_skeleton_main-500x500.jpg","chapterId":"623053322c9f8e0be9decc6a","chapterTitle":"The FundaMental","questionMarks":"15","topicId":"62bbec2051aac328684b2730","topicTitle":"test Topic question","created":"2022-07-12T06:04:52.919Z","updated":"2022-07-12T06:05:21.068Z","__v":0},
        {
            "_id": "62876d3c36dd500d0117e469",
            "hardtype": "easy",
            "tags": [
                "test"
            ],
            "placeHolders": [],
            "answerOptions": [
                "y",
                "ui",
                "i",
                "v"
            ],
            "optionvalues": [],
            "xvalues": [],
            "yvalues": [],
            "isActive": true,
            "isDeleted": false,
            "questionTitle": "<p>test question for mcq</p>\n",
            "subjectId": "62303c512c9f8e0be9decb06",
            "questionType": "mcq",
            "subjectTitle": "Biology",
            "explaination": "2 && 4 options are correct",
            "rightAnawer": "1,3",
            "classId": "623039992c9f8e0be9decae1",
            "classTitle": "KS3",
            "chapterId": "623053322c9f8e0be9decc6a",
            "chapterTitle": "The FundaMental Unit Of Life 2",
            "questionMarks": "2",
            "topicId": "623c715ae8e3cf3b03364b56",
            "topicTitle": "cell",
            "created": "2022-05-20T10:28:12.694Z",
            "updated": "2022-05-20T10:28:12.694Z",
            "__v": 0
        },
        {
            "_id": "627bbc83be9ecf108fe1a6d3",
            "hardtype": "easy",
            "tags": [
                "test question"
            ],
            "placeHolders": [],
            "answerOptions": [
                "cell"
            ],
            "optionvalues": [],
            "xvalues": [],
            "yvalues": [],
            "isActive": true,
            "isDeleted": false,
            "questionTitle": "<p>Define the term stem cell</p>\n",
            "subjectId": "62303c512c9f8e0be9decb06",
            "questionType": "descriptive",
            "subjectTitle": "Biology",
            "explaination": "Define the term stem cell",
            "rightAnawer": "[object Object]",
            "classId": "623039992c9f8e0be9decae1",
            "classTitle": "KS3",
            "chapterId": "623053322c9f8e0be9decc6a",
            "chapterTitle": "The FundaMental Unit Of Life 2",
            "questionMarks": "2",
            "topicId": "623c715ae8e3cf3b03364b56",
            "topicTitle": "cell",
            "created": "2022-05-11T13:39:15.824Z",
            "updated": "2022-05-11T13:39:15.824Z",
            "__v": 0
        },
        {
            "_id": "6287625d36dd500d0117e225",
            "hardtype": "easy",
            "tags": [
                "sample question"
            ],
            "placeHolders": [],
            "answerOptions": [
                "east",
                "west ",
                "north",
                "south"
            ],
            "optionvalues": [],
            "xvalues": [],
            "yvalues": [],
            "isActive": true,
            "isDeleted": false,
            "questionTitle": "<p>sample question</p>\n",
            "subjectId": "62303c512c9f8e0be9decb06",
            "questionType": "optional",
            "subjectTitle": "Biology",
            "explaination": "north",
            "rightAnawer": "2",
            "classId": "623039992c9f8e0be9decae1",
            "classTitle": "KS3",
            "chapterId": "623053322c9f8e0be9decc6a",
            "chapterTitle": "The FundaMental Unit Of Life 2",
            "questionMarks": "5",
            "topicId": "623c715ae8e3cf3b03364b56",
            "topicTitle": "cell",
            "created": "2022-05-20T09:41:49.842Z",
            "updated": "2022-05-20T09:41:49.842Z",
            "__v": 0
        },
        {
            "_id": "627bb1e0be9ecf108fe1a4c2",
            "hardtype": "easy",
            "tags": [
                "test "
            ],
            "placeHolders": [],
            "answerOptions": [
                "test",
                "grass",
                "tree"
            ],
            "optionvalues": [],
            "xvalues": [],
            "yvalues": [],
            "isActive": true,
            "isDeleted": false,
            "questionTitle": "<p>Which of the following is NOT true</p>\n",
            "subjectId": "62303c512c9f8e0be9decb06",
            "questionType": "optional",
            "subjectTitle": "Biology",
            "explaination": "option 3 is coreect",
            "rightAnawer": "2",
            "classId": "623039992c9f8e0be9decae1",
            "classTitle": "KS3",
            "chapterId": "623053322c9f8e0be9decc6a",
            "chapterTitle": "The FundaMental Unit Of Life 2",
            "questionMarks": "10",
            "topicId": "623c715ae8e3cf3b03364b56",
            "topicTitle": "cell",
            "created": "2022-05-11T12:53:52.816Z",
            "updated": "2022-05-11T12:53:52.816Z",
            "__v": 0
        },
        {
            "_id": "6296fa0e419e6b2db5d9c916",
            "hardtype": "medium",
            "tags": [
                "test"
            ],
            "placeHolders": [],
            "answerOptions": [
                "test "
            ],
            "optionvalues": [],
            "xvalues": [],
            "yvalues": [],
            "isActive": true,
            "isDeleted": false,
            "questionTitle": "<p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>\n",
            "subjectId": "62303c512c9f8e0be9decb06",
            "questionType": "descriptive",
            "subjectTitle": "Biology",
            "explaination": "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.",
            "rightAnawer": "[object Object]",
            "classId": "623039992c9f8e0be9decae1",
            "classTitle": "KS3",
            "chapterId": "623053322c9f8e0be9decc6a",
            "chapterTitle": "The FundaMental Unit Of Life 2",
            "questionMarks": "3",
            "topicId": "623c715ae8e3cf3b03364b56",
            "topicTitle": "cell",
            "created": "2022-06-01T05:33:02.139Z",
            "updated": "2022-06-01T05:33:02.139Z",
            "__v": 0
        },
        {
            "_id": "62876ced36dd500d0117e455",
            "hardtype": "medium",
            "tags": [
                "f"
            ],
            "placeHolders": [],
            "answerOptions": [
                "e",
                "f",
                "g",
                "h"
            ],
            "optionvalues": [],
            "xvalues": [],
            "yvalues": [],
            "isActive": true,
            "isDeleted": false,
            "questionTitle": "<p>f</p>\n",
            "subjectId": "62303c512c9f8e0be9decb06",
            "questionType": "optional",
            "subjectTitle": "Biology",
            "explaination": "f",
            "rightAnawer": "1",
            "classId": "623039992c9f8e0be9decae1",
            "classTitle": "KS3",
            "chapterId": "623053322c9f8e0be9decc6a",
            "chapterTitle": "The FundaMental Unit Of Life 2",
            "questionMarks": "5",
            "topicId": "623c715ae8e3cf3b03364b56",
            "topicTitle": "cell",
            "created": "2022-05-20T10:26:53.460Z",
            "updated": "2022-05-20T10:26:53.460Z",
            "__v": 0
        },
        {
            "_id": "627bb3cabe9ecf108fe1a4f1",
            "hardtype": "medium",
            "tags": [
                "test"
            ],
            "placeHolders": [
                "cell"
            ],
            "answerOptions": [],
            "optionvalues": [],
            "xvalues": [],
            "yvalues": [],
            "isActive": true,
            "isDeleted": false,
            "questionTitle": "protein Synthesis is _____",
            "subjectId": "62303c512c9f8e0be9decb06",
            "questionType": "fill",
            "subjectTitle": "Biology",
            "explaination": "Fill Type questions ",
            "rightAnawer": "protein Synthesis is cell",
            "classId": "623039992c9f8e0be9decae1",
            "classTitle": "KS3",
            "chapterId": "623053322c9f8e0be9decc6a",
            "chapterTitle": "The FundaMental Unit Of Life 2",
            "questionMarks": "5",
            "topicId": "623c715ae8e3cf3b03364b56",
            "topicTitle": "cell",
            "created": "2022-05-11T13:02:02.235Z",
            "updated": "2022-05-11T13:02:02.235Z",
            "__v": 0
        },
        {
            "_id": "6287617936dd500d0117e201",
            "hardtype": "medium",
            "tags": [],
            "placeHolders": [],
            "answerOptions": [
                "3"
            ],
            "optionvalues": [],
            "xvalues": [],
            "yvalues": [],
            "isActive": true,
            "isDeleted": false,
            "questionTitle": "<p>if 4*x = 12<br />\nwhat is value of x&nbsp;</p>\n",
            "subjectId": "62303c512c9f8e0be9decb06",
            "questionType": "descriptive",
            "subjectTitle": "Biology",
            "explaination": "x value 3",
            "rightAnawer": "[object Object]",
            "classId": "623039992c9f8e0be9decae1",
            "classTitle": "KS3",
            "chapterId": "623053322c9f8e0be9decc6a",
            "chapterTitle": "The FundaMental Unit Of Life 2",
            "questionMarks": "5",
            "topicId": "623c715ae8e3cf3b03364b56",
            "topicTitle": "cell",
            "created": "2022-05-20T09:38:01.123Z",
            "updated": "2022-05-20T09:38:01.124Z",
            "__v": 0
        }
    ],
    "type": "homework",
    "isActive": true,
    "isDeleted": false,
    "_id": "62c2e6c3348ce047fd8017ae",
    "userId": "6261373bb2dbe46deb6d19b0",
    "completed": "start",
    "topicId": "623c715ae8e3cf3b03364b56",
    "topicTitle": "cell",
    "time": "01:00:13",
    "chapterId": "623053322c9f8e0be9decc6a",
    "subjectId": "62303c512c9f8e0be9decb06",
    "classId": "623039992c9f8e0be9decae1",
    "created": "2022-07-04T13:10:27.990Z",
    "updated": "2022-07-04T13:10:27.990Z"
}